import { Theme, createStyles } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      gap: theme.spacing.unit,
      justifyContent: 'space-between',
    },
    infoWrapper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      rowGap: `${theme.spacing.unit * 2}px`,
      '& > div': {
        display: 'flex',
        alignItems: 'center',
        columnGap: `${theme.spacing.unit / 2}px`,
      },
    },
  });

export default styles;
